import { render } from "./PayPackages.vue?vue&type=template&id=062eb9a3&scoped=true&ts=true"
import script from "./PayPackages.vue?vue&type=script&lang=ts"
export * from "./PayPackages.vue?vue&type=script&lang=ts"

import "./PayPackages.vue?vue&type=style&index=0&id=062eb9a3&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062eb9a3"]])